import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  classCenters: [],
  campCenters: [],
  loading: false,
  error: null,
};

const centersListSlice = createSlice({
  name: 'centersList',
  initialState,
  reducers: {
    // Set class centers
    setClassCenters: (state, action) => {
      state.classCenters = action.payload;
    },

    // Set camp centers
    setCampCenters: (state, action) => {
      state.campCenters = action.payload;
    },

    // Set loading state
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    // Set error state
    setError: (state, action) => {
      state.error = action.payload;
    },

    // Clear all centers
    clearCenters: (state) => {
      state.classCenters = [];
      state.campCenters = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setClassCenters, setCampCenters, setLoading, setError, clearCenters } = centersListSlice.actions;
export default centersListSlice.reducer;
